import React from "react";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import Form from "../../Reusable/Form/Form.js";
import { useMail } from "../../../contexts/mailContext/mailContext.js";

const PasswordProtectedMessage = ({
  setFullScreenMessage,
  fullScreenMessage,
}) => {
  const { getTextByKey } = useContent();
  const { verifyMailPassword, fetchMailFiles } = useMail();
  const fields = {
    MailPassword: {
      fieldKey: "MailPassword",
      element: "input",
      type: "password",
      title: "MailPassword",
      label: "password-protected-field-title",
      placeholder: "password-protected-field-title",
      hidePassStrength: true,
    },
  };
  const handleSubmit = async (body) => {
    const response = await verifyMailPassword(
      body.MailPassword,
      body.recaptchaResponse
    );
    if (response.status === "success") {
      setFullScreenMessage({ ...fullScreenMessage, isShow: false });
      fetchMailFiles();
      return response;
    }
    return response;
  };

  return (
    <div className="mail-message-container">
      <Form
        fields={fields}
        formClass="password-protected"
        buttonProps={{ buttonsSize: "large" }}
        fieldsProps={{ label: "hidden", field: "square" }}
        onSubmit={handleSubmit}
        submitProps={{
          title: getTextByKey("submit"),
          className: "full-width-button",
        }}
        captchaProvider="cloudflare"
        cloudflareActionName="verifyMailPassword"
      />
    </div>
  );
};

export default PasswordProtectedMessage;
